module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/file-cloud-a343bd365476835d92728ca24fcf52a6.svg";